import { getItem, setItem } from '@alltrails/core/utils/localStorage';
import type { AlgoliaResultType } from '@alltrails/types/Algolia';
import type { AlgoliaHit, RecentAlgoliaHit } from '@alltrails/types/AlgoliaResults';
import type AlgoliaIndex from './AlgoliaIndex';

export const RECENT_ALGOLIA_HITS_STORAGE_KEY = 'algolia-recent-searches';
export const RECENT_SEARCHES_DISPLAY_LIMIT = 5;
const maxStored = 50;

const getStoredHits = () => getItem<RecentAlgoliaHit[]>(RECENT_ALGOLIA_HITS_STORAGE_KEY) ?? [];

export const getRecentAlgoliaHits = (types: 'all' | AlgoliaResultType[], maxCount?: number) => {
  const filteredRecentHits = getStoredHits().filter(hit => types === 'all' || types.includes(hit.type));
  return maxCount ? filteredRecentHits.slice(0, maxCount) : filteredRecentHits;
};

/**
 * Loads the full Algolia records for the stored recent hits. Records that no longer exist in the index are dropped.
 */
export const getRecentAlgoliaObjects = async (index: AlgoliaIndex, types: 'all' | AlgoliaResultType[], maxCount?: number) => {
  const recentHits = getRecentAlgoliaHits(types, maxCount);
  if (!recentHits.length) {
    return [];
  }

  const response = await index.getObjects(recentHits.map(hit => hit.objectID));
  return response.results.filter((hit): hit is AlgoliaHit => Boolean(hit));
};

export const addRecentAlgoliaHit = (recentHit: RecentAlgoliaHit) => {
  const nextHits = [recentHit, ...getStoredHits().filter(hit => hit.objectID !== recentHit.objectID)];
  setItem(RECENT_ALGOLIA_HITS_STORAGE_KEY, nextHits.slice(0, maxStored));
};
